// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1SnhE","header":"Messages_header__2EOYN"};